module.exports = __webpack_public_path__ + "96389d05899aa7ffeb36415813f126ef.png";